import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

export interface Location {
  id: string;
  code: string;
  name: string;
  branch_id: string | null;
  is_active: boolean;
}

/**
 * The showcases, safes and strong rooms a piece can be kept in.
 *
 * Filtered to one branch when asked, because a piece at the Main Showroom is
 * never placed in the Anna Nagar window — and a location with no branch set is
 * offered everywhere.
 */
export function useLocations(branchId?: string | null): { locations: Location[]; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['locations'],
    queryFn: () => api.get<{ data: Location[] }>('/locations?limit=200'),
    // Short, so a location added from the "＋ New" link shows up on return.
    staleTime: 10_000,
  });
  const all = (data?.data ?? []).filter((l) => l.is_active);
  return {
    locations: branchId ? all.filter((l) => !l.branch_id || l.branch_id === branchId) : all,
    isLoading,
  };
}
